import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";

const RptDetail = ({
                     propType,
                     propName,
                     propStatus,
                   }) => {
  return (
      <>
        <h6 className={"info-container-title text-center mt-3"}>{propName} 상태 정보</h6>
        <div className={'content-container-body-item'}>
          <Form
              className={'gateway-register-form py-3'}
              id={'gatewayRegisterForm'}
          >
            <Row className={""}>
              <Col md={6}>
                <Row>
                  <Col md={12}>
                    <Form.Group as={Row} controlId="formFcltyNm">
                      <Form.Label column md={4} className={'label text-end'}>
                        최근수집시간
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.mesure_dt_str || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFloor'>
                      <Form.Label column md={4} className={'label text-end'}>
                        펌웨어버전
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.FW_VER || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formEqmTy'>
                      <Form.Label column md={4} className={'label text-end'}>
                        채널
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.SENSOR_RPEAT_CHNNL || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='forml2IpAddr'>
                      <Form.Label column md={4} className={'label text-end'}>
                        온도
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.tp || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='forml2IpAddr'>
                      <Form.Label column md={4} className={'label text-end'}>
                        습도
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.hd || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label  text-end'}>
                        배터리
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.btry_rate || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label text-end'}>
                        485 RID1 상태
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.rf485_rpeat1_cnnc_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label text-end'}>
                        485 RID2 상태
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.rf485_rpeat2_cnnc_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label text-end'}>
                        485 RID3 상태
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.rf485_rpeat3_cnnc_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>

              <Col md={6}>
                <Row>
                  <Col md={12}>
                    <Form.Group as={Row} controlId="formFcltyNm">
                      <Form.Label column md={4} className={'label text-end'}>
                        배터리상태
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.btry_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFloor'>
                      <Form.Label column md={4} className={'label text-end'}>
                        AC 상태
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.ac_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formEqmTy'>
                      <Form.Label column md={4} className={'label text-end'}>
                        rf1 상태
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.rf1_abnrml_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='forml2IpAddr'>
                      <Form.Label column md={4} className={'label text-end'}>
                        rf2 상태
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.rf2_abnrml_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='forml2IpAddr'>
                      <Form.Label column md={4} className={'label text-end'}>
                        flash 상태
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.flash_err_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label  text-end'}>
                        습도센서 상태
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.tphd_abnrml_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label text-end'}>
                        템퍼 상태
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.tamper_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label text-end'}>
                        ICI 상태
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.chnnl_chg_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label text-end'}>
                        RF혼잡 상태
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.cnf_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>

            </Row>
          </Form>
        </div>
      </>
  );
};

export default RptDetail;
